import { SettingsShell } from 'shared/settings';
import SettingsPageRoutes from './SettingsPageRoutes';
import useSettingsHostProps from './useSettingsHostProps';

export default function SettingsPage() {
  const settingsHostProps = useSettingsHostProps();

  return (
    <SettingsShell {...settingsHostProps}>
      <SettingsPageRoutes />
    </SettingsShell>
  );
}
